import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { MarketplaceIntegration } from '../../types'
import { Card, CardContent, CardTitle, CardDescription } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Switch } from '@/components/ui/switch'
import { Button } from '@/components/ui/button'

interface IProps {
  integration: MarketplaceIntegration
  onClick: () => void
  onDisconnect: () => void
}

const IntegrationCard = (props: IProps) => {
  const { integration, onClick, onDisconnect } = props
  const { t } = useTranslation()

  const { name, description, icon, image, connected, new: isNew } = integration

  const onCheckedChange = (checked: boolean) => {
    if (checked) {
      onClick()
    } else {
      onDisconnect()
    }
  }

  return (
    <Card
      className='cursor-pointer gap-4 transition-shadow hover:shadow-md'
      onClick={onClick}
    >
      <CardContent className='flex flex-col gap-4'>
        <div className='flex items-start gap-3'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted ring-1 ring-foreground/10'>
            <img src={icon || image} alt={name} className='size-6 object-contain' />
          </div>

          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-2'>
              <CardTitle>{name}</CardTitle>
              {isNew && !connected && <Badge variant='secondary'>{t('IntegrationCard::New')}</Badge>}
            </div>
            <CardDescription className='line-clamp-2'>{description}</CardDescription>
          </div>
        </div>

        <div className='flex items-center justify-between' onClick={(e) => e.stopPropagation()}>
          <Button variant='outline' onClick={onClick}>{t('IntegrationCard::Details')}</Button>
          <Switch checked={Boolean(connected)} onCheckedChange={onCheckedChange} />
        </div>
      </CardContent>
    </Card>
  )
}

export default IntegrationCard
